import * as React from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazyload';
import { withMedia } from 'react-media-query-hoc';
// import { renderToStaticMarkup } from 'react-dom/server';
import { Fade, Slide } from 'react-reveal';
import { AndroidStoreLink, AppleStoreLink } from '@origin-digital/style-guide';

import { BREAK_POINTS } from '../../consts/style';
import { Byline, Heading1 } from '../Text';
import { IDamImage, IDigitalAdoption } from '../../models/content.interfaces';
import { target } from '@origin-digital/utils';
import { get } from 'lodash';
import { ResponsiveImage } from '../Image';
import { RaySVG } from './RaySVG';
import burstMobileBackground from './Triple_Energy_Burst_01_O_RGB_Yellow_394x197_png-8_@2x.png';
// import { BurstMobileBackground } from './BurstMobileBackground';
// const burstMobileBackground = "";

// const burstMobileBackgroundSvgString = encodeURIComponent(
//   renderToStaticMarkup(<BurstMobileBackground />)
// );
// const burstMobileBackgroundSvgDataUri = `url("data:image/svg+xml,${burstMobileBackgroundSvgString}")`;

const burstMobileBackgroundSvgDataUri = `url("${burstMobileBackground}")`;

const BannerH1 = Heading1.extend`
  margin: 0 0 24px 0;
`.withComponent('h2');

const DigitalAdoptionContainer = styled.section`
  padding: 32px 16px 0px 16px;
  box-sizing: border-box;
  // overflow: hidden;
  max-width: 1140px;
  // background: white;
  justify-content: center;
  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    align-items: center;
    display: flex;
    padding: 0px 0px;
  }

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    align-items: center;
    min-height: 320px;
  }

  @media (min-width: ${BREAK_POINTS.MIN.LG}) {
    // overflow: visible;
  }
`;

const DigitalAdoptionInner = styled.div`
  display: inline-block;
  // margin: 0 auto;
  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    max-width: 280px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    max-width: 328px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    max-width: 420px;
    min-width: 294px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.LG}) {
    margin: 0 95px;
  }
`;

const DigitalAdoptionInner2 = styled.div`
  display: inline-block;
  // margin: 0 auto;
  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    max-width: 300px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    max-width: 379px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    min-width: 294px;
    max-width: 420px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.LG}) {
    max-width: 530px;
  }
  width: 100%;
`;

interface mediaProps {
  mobile: boolean;
  xlarge: boolean;
  large: boolean;
  tablet: boolean;
  desktop: boolean;
}

interface DigitalAdoptionPureProps {
  buttonLink: string;
  button2Link: string;
  button2Svg: string;
  button1Link: string;
  button1Svg: string;
  devicesDesktopImage: IDamImage;
  devicesMobileImage: IDamImage;
  bannerImageTitle: string;
  bannerImageAlt: string;
  headline: string;
  byline: string;
  postCodeValue: string;
  showFindOutMore: boolean;
  media: mediaProps;
}

const BackGroundContainer = styled.div`
  position: relative;
  height: 369px;
  text-align: center;

  @media (min-width: 360px) {
    height: 419px;
  }

  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    height: 419px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    height: 538px;
  }
`;

const MobileApplicationImageContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 40px;
  // left: -10px;
  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    top: 40px;
    left: 0px;
    max-width: 353px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    top: 40px;
    left: 10px;
    max-width: 353px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    top: 0px;
    left: -20px;
    max-width: 353px;
  }
`;

const SlideContainer = styled.div`
  height: 100px;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    height: 150px;
  }
`;

const BurstMobileBackgroundContainer = styled.div`
  position: relative;
  width: 790px;
  height: 790px;
  background: ${burstMobileBackgroundSvgDataUri};
  background-repeat: no-repeat;
  background-position: 0 80px;
  background-size: contain;
`;

const ButtonsContainer = styled.div`
  display: flex;

  & > *:not(:last-child) {
    margin-right: 12px;
  }
`;

// const appDownloadTracking = isAppleStore => () => {
//   interaction('click', {
//     componentType: 'link',
//     id: isAppleStore ? 'download-it-on-the-app-store' : 'get-it-on-google-play',
//     parentContainer: 'digital_adoption_banner',
//     appName: 'digital_adoption_banner',
//     label: isAppleStore ? 'Download on the App Store' : 'Get it on Google Play',
//   });
// };

export const DigitalAdoptionPure = withMedia(
  ({
    headline,
    byline,
    media,
    button2Link,
    button1Link,
    devicesDesktopImage,
    devicesMobileImage,
    bannerImageAlt,
  }: DigitalAdoptionPureProps) => (
    <DigitalAdoptionContainer data-comment="DigitalAdoptionCampaign">
      <Fade
        effect="fadeIn"
        duration={1500}
        delay={media.mobile ? 0 : 200}
        ssrFadeout={true}
        ssrReveal
      >
        <DigitalAdoptionInner>
          <BannerH1>{headline}</BannerH1>

          <div style={{ marginBottom: '32px' }}>
            <Byline>{byline}</Byline>
          </div>

          <ButtonsContainer>
            {button2Link && (
              <AppleStoreLink componentType="link" href={button2Link} target="_blank" />
            )}
            {button1Link && (
              <AndroidStoreLink componentType="link" href={button1Link} target="_blank" />
            )}
          </ButtonsContainer>
        </DigitalAdoptionInner>
      </Fade>
      <DigitalAdoptionInner2>
        <BackGroundContainer>
          {media.mobile ? (
            <BurstMobileBackgroundContainer />
          ) : (
            <LazyLoad height={500} debounce={60}>
              <div
                style={{
                  left: 0,
                  position: 'absolute',
                  width: '790px',
                  height: '442px',
                }}
              >
                <RaySVG />
              </div>
            </LazyLoad>
          )}

          <MobileApplicationImageContainer>
            {media.xlarge || media.large ? (
              <Slide duration={1500} bottom>
                <SlideContainer>
                  <ResponsiveImage
                    image={devicesDesktopImage}
                    imageWidths={[212, 425, 650]}
                    sizes={{
                      XS: '536px',
                      SM: '536px',
                      MD: '536px',
                      LG: '536px',
                    }}
                    maxWidth="536px"
                    style={{ width: '536px' }}
                    alt={bannerImageAlt}
                  />
                </SlideContainer>
              </Slide>
            ) : (
              <Slide duration={1500} bottom ssrFadeout ssrReveal>
                <SlideContainer>
                  <ResponsiveImage
                    image={devicesMobileImage || devicesDesktopImage}
                    imageWidths={[212, 425, 650]}
                    sizes={{
                      XS: '353px',
                      SM: '353px',
                      MD: '353px',
                      LG: '353px',
                    }}
                    maxWidth="350px"
                    style={{ width: '350px' }}
                    alt={bannerImageAlt}
                  />{' '}
                </SlideContainer>
              </Slide>
            )}
          </MobileApplicationImageContainer>
        </BackGroundContainer>
      </DigitalAdoptionInner2>
    </DigitalAdoptionContainer>
  ),
);

export class DigitalAdoptionCampaign extends React.Component<IDigitalAdoption> {
  constructor(props: any, state: any) {
    super(props, state);
  }
  ABTestEC835 = () => {
    return new Promise((resolve) => {
      if (target.isAvailable()) {
        target.applyABTest(
          'EC-835-mbox',
          (offer) => {
            if (get(offer, '[0].content[0].experienceId') === 'Experience B') {
              return resolve(true);
            } else {
              return resolve(false);
            }
          },
          () => resolve(false),
        );
      } else {
        return resolve(false);
      }
    });
  };

  componentDidMount() {
    this.ABTestEC835().then((response) => {
      if (response === true) {
        this.setState({ showFindOutMore: true });
      }
    });
  }

  render() {
    const buttonLink = '/app.html';
    return (
      <DigitalAdoptionPure
        data-comment="DigitalAdoption"
        {...this.props}
        {...this.state}
        buttonText={'Learn more about the app'}
        buttonLink={buttonLink}
      />
    );
  }
}
